import { render, staticRenderFns } from "./TheCaseChangeHistory.vue?vue&type=template&id=2d86d954&"
import script from "./TheCaseChangeHistory.vue?vue&type=script&lang=js&"
export * from "./TheCaseChangeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports